export const getLineButtonStyles = (disabled: Boolean) => ({
  ...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BACKGROUND_COLOR && !disabled
      ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BACKGROUND_COLOR }
      : {}
  ),
  ...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_TEXT_COLOR
      ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_TEXT_COLOR }
      : {}
  ),
  ...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BOX_SHADOW
      ? { boxShadow: process.env.REACT_APP__UI_CUSTOMIZATION__LOGIN_PAGE__LINE_BUTTON_BOX_SHADOW }
      : {}
  )
});


export const getListRewardPageViewMoreButtonStyles  = ({
  ...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_BACKGROUND_COLOR
        ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_BACKGROUND_COLOR }
        : {}
),
...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_TEXT_COLOR
        ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__VIEW_MORE_ITEMS_BUTTON_TEXT_COLOR }
        : {}
)
});

export const getListRewardPageUseNowButtonStyles  = ({
  ...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_BACKGROUND_COLOR
        ? { backgroundColor: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_BACKGROUND_COLOR }
        : {}
),
...(
    process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_TEXT_COLOR
        ? { color: process.env.REACT_APP__UI_CUSTOMIZATION__LIST_REWARD_PAGE__USE_NOW_BUTTON_TEXT_COLOR }
        : {}
)
});
